export default "/images/6685142b39b302dd1cc0c676eb569db8.avif";